/** Columns returned for chat message rows (queries, inserts, realtime merge). */
export const MESSAGE_SELECT_FIELDS =
  'id, created_at, content, user_id, sender_name, sender_avatar_url, event_id, direct_chat_id, image_url, file_url, file_name, file_size, type, mentions';
